import classNames from "classnames";
import { useId } from "react";
import { TooltipTemplate } from "UiKit/Tooltips";
import styles from "./ButtonTemplate.module.css";
import React from "react";
function ButtonTemplate({ onClick, tooltipMessage, tooltipPosition = "top", children, role = "button", isLoading = false, isError, isActive, disabled, className, classNameContent, elementAttr, ...props }) {
    const id = useId();
    const onClickButton = (e) => {
        if (onClick) {
            e.stopPropagation();
            onClick(e);
        }
    };
    return (React.createElement("button", { id: id, type: "button", role: role, className: classNames(styles.template, className), onClick: onClickButton, disabled: isLoading || disabled, "data-loading": isLoading, "data-error": isError, "data-active": isActive, ...props, ...elementAttr },
        React.createElement("div", { className: classNames(styles["button-content"], classNameContent) }, children),
        tooltipMessage && (React.createElement(TooltipTemplate, { id: id, position: tooltipPosition },
            React.createElement("span", null, tooltipMessage)))));
}
export default ButtonTemplate;
